import React, {Component, FormEvent, RefObject} from 'react';
import {ValidationGroup} from 'util/validation';
import './index.scss';

export enum FormStatus {
  None,
  Submitting,
  Success,
  Failure
}

interface FormProps {
  validationGroup?: ValidationGroup;
  onSubmit?: ()=>void;
  className?: string;
  formRef?: RefObject<HTMLFormElement>;
}

export default class Form extends Component<FormProps, {}> {
  onSubmit = (ev: FormEvent) => {
    ev.preventDefault();
    const validationGroup = this.props.validationGroup;
    const onSubmit = this.props.onSubmit;
    if(validationGroup) {
      validationGroup.validate(true).then(
        isValid => {
          if(isValid && onSubmit) {
            onSubmit();
          }
        }
      );
    } else if(onSubmit) {
      onSubmit();
    }
  };

  render() {
    return <form onSubmit={this.onSubmit} noValidate={true} className={this.props.className} ref={this.props.formRef}>
      { this.props.children }
    </form>;
  }
}